import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NotificationManager } from 'react-notifications';
import { Grid, Search, Table, Button, Divider } from 'semantic-ui-react';

import {
  AvForm,
  AvField,
  AvCheckbox,
  AvCheckboxGroup,
} from 'availity-reactstrap-validation';

import {
  isEmpty,
  cloneDeep,
  debounce,
  isString,
  get,
  includes,
} from '../../../../utils/lodash';

import { CustomTooltip } from '../../../../components';
import { DuplicatePermissionCheckbox } from '../../../../components/permissions';
import { RESTRICTION_TYPES, permissionTypes } from '../../../../utils/constant';
import {
  getPermissionType,
  hasDuplicatePermission,
  withoutDuplicatePermission,
  withDuplicatePermission,
  duplicateDefaultForPreset,
  isDuplicateLocked,
} from '../../../../utils/activity/userPermission';

import {
  addActivityMember,
  updateActivityMember,
  getOrgMembers,
} from '../../../../store/actions';

import '../activity.scss';

class ActivityMember extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      searchQuery: '',
      form: {
        firstName: '',
        surName: '',
        email: '',
        message: '',
      },
      permissionType: undefined,
      radioType: undefined,
      collaborator: false,
      documentor: false,
      reportOnly: false,
      permissions: [],
      permissionError: false,
      dropdownValuePermission: '',
      isCustomNotEmpty: true, //false means empty
      isPermissionLabelVisible: false,
      canDuplicate: false, // TAK-2080
    };
  }

  componentDidMount() {
    const { editPermission, participant, inviteUser, t } = this.props;

    let permissionArray = [];
    let canDuplicate = false;
    if (editPermission) {
      if (isString(participant.permissions)) {
        participant.permissions = JSON.parse(participant.permissions);
      }
      // TAK-2080: the table shows the pages; Duplicate has its own box
      permissionArray = withoutDuplicatePermission(participant.permissions);
      canDuplicate = hasDuplicatePermission(participant.permissions);
    } else {
      permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.value,
          permission: {
            read: false,
            write: false,
          },
          state: permissionType.state,
        };
      });
    }
    this.setState({
      permissionArray,
      canDuplicate,
      dropdownValuePermission: inviteUser
        ? ''
        : getPermissionType(permissionArray),
    });
  }

  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () =>
    this.setState({
      isLoading: false,
      data: [],
      searchQuery: '',
    });

  handleResultSelect = (user) => {
    if (isEmpty(user)) {
      return false;
    } else {
      this.setState(
        {
          form: {
            firstName: user.firstName,
            surname: user.surname,
            email: user.email,
          },
        },
        () => {
          this.form && this.form.reset();
        }
      );
    }
  };

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: true, searchQuery: value }, async () => {
      try {
        const { getOrgMembers } = this.props;
        await getOrgMembers(value);
        let { orgMembers } = this.props;
        setTimeout(async () => {
          if (this.state.searchQuery.length < 1) return this.resetComponent();
          // orgMembers = map(orgMembers, member => {
          //   const exist = find(
          //     actMembers,
          //     actMember => member.email === actMember.user.email
          //   );
          //   if (!exist) return member;
          // });
          this.setState({
            isLoading: false,
            data: orgMembers || [],
          });
        }, 300);
      } catch (error) {
        // console.error('handleSearchChange -> error', error);
      }
    });
  };

  async handlePermissionSubmit() {
    const { t } = this.props;
    try {
      const { permissionArray, isCustomNotEmpty } = this.state;
      const { updateActivityMember, participant } = this.props;

      if (isCustomNotEmpty) {
        await updateActivityMember(
          participant,
          withDuplicatePermission(permissionArray, this.canDuplicateOnSave())
        );
        this.setState(
          {
            isLoading: false,
            data: [],
            searchQuery: '',
            form: {
              firstName: '',
              surName: '',
              email: '',
              message: '',
            },
            isCustomNotEmpty: true, //false means empty
            isPermissionLabelVisible: false,
          },
          () => {
            NotificationManager.success(
              t('activity.activity_plan.participant_permission_update_success'),
              t('activity.activity_plan.permission_changed')
            );
            this.props.toggle();
          }
        );
      } else {
        this.setState({
          isPermissionLabelVisible: true,
        });
      }
    } catch (error) {
      NotificationManager.error(
        t('activity.activity_plan.couldnt_change_permissions'),
        t('common.something_went_wrong')
      );
    }
  }

  handleInvalidSubmit() {
    if (!this.state.permissionType) {
      this.setState({ permissionError: true });
    }
  }

  async handleValidSubmit(event, values) {
    const { addActivityMember, currentActivity, t } = this.props;
    try {
      if (!this.state.permissionType) {
        this.setState({ permissionError: true });
        return false;
      }
      values.projectId = currentActivity.id;
      values.permissions = withDuplicatePermission(
        this.state.permissionArray,
        this.canDuplicateOnSave()
      );

      await addActivityMember(values);
      this.setState(
        {
          isLoading: false,
          data: [],
          searchQuery: '',
          form: {
            firstName: '',
            surName: '',
            email: '',
            message: '',
          },
        },
        () => {
          this.form && this.form.reset();
          NotificationManager.success(
            t('activity.activity_plan.user_added_activity'),
            t('activity.activity_plan.participant_adding_success')
          );
          this.props.toggle();
        }
      );
    } catch (error) {
      NotificationManager.error(
        t('activity.activity_plan.couldnt_add_participant'),
        t('common.something_went_wrong')
      );
    }
  }

  // TAK-2080: the Duplicate box only counts for presets that allow it
  canDuplicateOnSave() {
    const { canDuplicate, dropdownValuePermission } = this.state;
    return canDuplicate && !isDuplicateLocked(dropdownValuePermission);
  }

  renderDuplicateCheckbox() {
    const { participant } = this.props;
    const { canDuplicate, dropdownValuePermission } = this.state;
    return (
      <DuplicatePermissionCheckbox
        checked={canDuplicate}
        disabled={
          isDuplicateLocked(dropdownValuePermission) ||
          get(participant, 'isProgramCollaborator', false)
        }
        onChange={(checked) => this.setState({ canDuplicate: checked })}
      />
    );
  }

  selectPermissionType(value, name, checked) {
    const { t } = this.props;
    // TAK-2080: on for Collaborator, off for every other preset
    this.setState({ canDuplicate: duplicateDefaultForPreset(value) });
    if (value === 'collaborator') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.value,
          permission: {
            read: true,
            write: RESTRICTION_TYPES.includes(permissionType.state)
              ? false
              : true,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.collaborator'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'collaborator',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'documentor') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.value,
          permission: {
            read: permissionType.documentor ? true : false,
            write: permissionType.documentor
              ? RESTRICTION_TYPES.includes(permissionType.state)
                ? false
                : true
              : false,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.documentor'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'documentor',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'reportOnly') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.value,
          permission: {
            read: permissionType.reportOnly ? true : false,
            write: permissionType.reportOnly
              ? RESTRICTION_TYPES.includes(permissionType.state)
                ? false
                : true
              : false,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.report_only'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'reportOnly',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'custom') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.value,
          permission: {
            read: false,
            write: false,
          },
          state: permissionType.state,
        };
      });

      let isCustomEmpty = permissionArray.map((item) => {
        return item.permission.read === false && item.permission.write === false
          ? true
          : false;
      });

      this.setState({
        permissionArray,
        permissionType: t('permission_type.custom'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'custom',
        isCustomNotEmpty: includes(isCustomEmpty, false), //false means empty
        isPermissionLabelVisible: false,
      });
    }
  }

  selectPermissionOption(checked, value, id, type) {
    const { t } = this.props;

    this.setState((preState) => {
      let permissionArray = cloneDeep(preState.permissionArray);
      if (!checked && type === 'read') {
        permissionArray[id].permission.write = false;
      }
      permissionArray[id].permission[type] =
        !preState.permissionArray[id].permission[type];

      let dropdownValue = getPermissionType(permissionArray);

      let isCustomEmpty = permissionArray.map((item) => {
        return item.permission.read === false && item.permission.write === false
          ? true
          : false;
      });

      return {
        ...preState,
        permissionArray: permissionArray,
        permissionType: t('permission_type.custom'),
        radioType: undefined,
        permissionError: false,
        dropdownValuePermission: dropdownValue,
        isCustomNotEmpty: includes(isCustomEmpty, false),
        isPermissionLabelVisible: false,
        // TAK-2080: switching to a preset that can't duplicate turns it off
        canDuplicate: isDuplicateLocked(dropdownValue)
          ? false
          : preState.canDuplicate,
      };
    });
  }

  renderDropdown = () => {
    const { t } = this.props;
    const {
      permissionArray,
      permissionError,
      dropdownValuePermission,
      isPermissionLabelVisible,
    } = this.state;

    const { editPermission, actPut, user, helpTips, participant } = this.props;
    return (
      <AvForm
        className="permission-form invite-user-modal-custom"
        onValidSubmit={() => this.handlePermissionSubmit()}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="new-member-segment-custom">
                <CustomTooltip
                  state={get(user, 'options.tips')}
                  contentObject={{
                    data: helpTips,
                    key: '125',
                  }}
                  position="top left"
                  wide="very"
                >
                  <label>{t('common.permission')}</label>
                </CustomTooltip>
                <AvField
                  type="select"
                  name="permission" //this will be deleted in handle valid submit
                  // label="REPORT TYPE"
                  // className="report-selector"
                  className={`permission-dropdown-custom ${
                    permissionError ? 'invalid-input ' : ' '
                  }`}
                  // required
                  onChange={(e) =>
                    this.selectPermissionType(
                      e.target.value,
                      e.target.name,
                      e.target.checked
                    )
                  }
                  value={dropdownValuePermission}
                  disabled={get(participant, 'isProgramCollaborator', false)}
                >
                  <option value="" defaultValue disabled>
                    {t('formulary.placeholder.select_permission_type')}
                  </option>
                  <option value="collaborator" name="collaborator">
                    {t('permission_type.collaborator')}
                  </option>
                  <option value="documentor" name="documentor">
                    {t('permission_type.documentor')}
                  </option>
                  <option value="reportOnly" name="reportOnly">
                    {t('permission_type.report_only')}
                  </option>
                  <option value="custom" name="custom">
                    {t('permission_type.custom')}
                  </option>
                </AvField>
              </div>
            </Grid.Column>

            <Table className="table-edit-custom-participant">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    <span className="activity-section-cell-custom">
                      {t('activity.activity_plan.activity_section')}
                    </span>{' '}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    <span className="empty-cell-space-outer-custom">
                      {t('actions.read')}
                      <label className="empty-cell-space-custom"></label>
                      {t('actions.write')}
                    </span>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {permissionTypes(t).map((permissionType, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell>{permissionType.title}</Table.Cell>
                      <Table.Cell>
                        <AvCheckboxGroup inline name={permissionType.title}>
                          <AvCheckbox
                            onChange={(e) =>
                              this.selectPermissionOption(
                                e.target.checked,
                                e.target.value,
                                permissionType.id - 1,
                                'read'
                              )
                            }
                            // label="Read"
                            value={permissionType.value}
                            checked={
                              permissionArray
                                ? permissionArray[permissionType.id - 1]
                                    .permission.read
                                : false
                            }
                            disabled={get(
                              participant,
                              'isProgramCollaborator',
                              false
                            )}
                          />
                          {RESTRICTION_TYPES.includes(
                            permissionType.state
                          ) ? null : (
                            <AvCheckbox
                              onChange={(e) =>
                                this.selectPermissionOption(
                                  e.target.checked,
                                  e.target.value,
                                  permissionType.id - 1,
                                  'write'
                                )
                              }
                              // label="Write"
                              value={permissionType.value}
                              checked={
                                permissionArray
                                  ? permissionArray[permissionType.id - 1]
                                      .permission.write
                                  : false
                              }
                              disabled={
                                permissionArray
                                  ? !permissionArray[permissionType.id - 1]
                                      .permission.read
                                  : false
                              }
                            />
                          )}
                        </AvCheckboxGroup>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
            {this.renderDuplicateCheckbox()}
            {isPermissionLabelVisible ? (
              <div className="invalid-permission-custom">
                {t(
                  'activity.activity_plan.please_set_permissions_activity_member'
                )}
              </div>
            ) : null}
          </Grid.Row>
          <Grid.Column
            // mobile={16}
            // tablet={16}
            // computer={16}
            width={16}
            floated="right"
          >
            {editPermission ? (
              <Button
                type="submit"
                className="Primary-Button"
                disabled={actPut.activityMembers ? true : false}
                loading={actPut.activityMembers ? true : false}
              >
                <div>{t('activity.activity_plan.update_permissions')}</div>
              </Button>
            ) : null}
          </Grid.Column>
        </Grid>
      </AvForm>
    );
  };

  renderParticipantDropdown = () => {
    const {
      permissionArray,
      permissionError,
      dropdownValuePermission,
      isPermissionLabelVisible,
    } = this.state;

    const { editPermission, actPut, user, helpTips, t } = this.props;
    return (
      <AvForm
        className="permission-form-custom"
        onValidSubmit={() => this.handlePermissionSubmit()}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <div className="new-member-segment-custom-participant">
                <CustomTooltip
                  state={get(user, 'options.tips')}
                  contentObject={{
                    data: helpTips,
                    key: '125',
                  }}
                  position="top left"
                  wide="very"
                >
                  <label className="permission-edit">
                    {t('common.permission')}
                  </label>
                </CustomTooltip>
                <AvField
                  type="select"
                  name="permission" //this will be deleted in handle valid submit
                  // label="REPORT TYPE"
                  // className="report-selector"
                  className={`permission-dropdown-custom ${
                    permissionError ? 'invalid-input ' : ' '
                  }`}
                  // required
                  onChange={(e) =>
                    this.selectPermissionType(
                      e.target.value,
                      e.target.name,
                      e.target.checked
                    )
                  }
                  value={dropdownValuePermission}
                >
                  <option value="" defaultValue disabled>
                    {t('formulary.placeholder.select_permission_type')}
                  </option>
                  <option value="collaborator" name="collaborator">
                    {t('permission_type.collaborator')}
                  </option>
                  <option value="documentor" name="documentor">
                    {t('permission_type.documentor')}
                  </option>
                  <option value="reportOnly" name="reportOnly">
                    {t('permission_type.report_only')}
                  </option>
                  <option value="custom" name="custom">
                    {t('permission_type.custom')}
                  </option>
                </AvField>
              </div>
            </Grid.Column>

            <Table className="table-edit-custom-participant">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    <span className="activity-section-cell-custom">
                      {t('activity.activity_plan.activity_section')}
                    </span>{' '}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    <span className="empty-cell-space-outer-custom">
                      {t('actions.read')}
                      <label className="empty-cell-space-custom"></label>
                      {t('actions.write')}
                    </span>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {permissionTypes(t).map((permissionType, i) => {
                  return (
                    <Table.Row key={i}>
                      <Table.Cell>{permissionType.title}</Table.Cell>
                      <Table.Cell>
                        <AvCheckboxGroup inline name={permissionType.title}>
                          <AvCheckbox
                            onChange={(e) =>
                              this.selectPermissionOption(
                                e.target.checked,
                                e.target.value,
                                permissionType.id - 1,
                                'read'
                              )
                            }
                            // label="Read"
                            value={permissionType.value}
                            checked={
                              permissionArray
                                ? permissionArray[permissionType.id - 1]
                                    .permission.read
                                : false
                            }
                          />
                          {RESTRICTION_TYPES.includes(
                            permissionType.state
                          ) ? null : (
                            <AvCheckbox
                              onChange={(e) =>
                                this.selectPermissionOption(
                                  e.target.checked,
                                  e.target.value,
                                  permissionType.id - 1,
                                  'write'
                                )
                              }
                              // label="Write"
                              value={permissionType.value}
                              checked={
                                permissionArray
                                  ? permissionArray[permissionType.id - 1]
                                      .permission.write
                                  : false
                              }
                              disabled={
                                permissionArray
                                  ? !permissionArray[permissionType.id - 1]
                                      .permission.read
                                  : false
                              }
                            />
                          )}
                        </AvCheckboxGroup>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
            {this.renderDuplicateCheckbox()}
            {isPermissionLabelVisible ? (
              <div className="invalid-permission-custom">
                {t(
                  'activity.activity_plan.please_set_permissions_activity_member'
                )}
              </div>
            ) : null}
          </Grid.Row>
          <Grid.Column
            // mobile={16}
            // tablet={16}
            // computer={16}
            width={7}
            floated="right"
          >
            {editPermission ? (
              <Button
                type="submit"
                className="permission-edit-button"
                disabled={actPut.activityMembers ? true : false}
                loading={actPut.activityMembers ? true : false}
              >
                <div>{t('activity.activity_plan.update_permissions')}</div>
              </Button>
            ) : null}
          </Grid.Column>
        </Grid>
      </AvForm>
    );
  };

  render() {
    const {
      isLoading,
      data,
      searchQuery,
      form,
      permissionError,
      isPermissionLabelVisible,
    } = this.state;
    const { user, helpTips, editPermission, actPut, currentActivity, t } =
      this.props;
    return (
      <div className="act-member-segment">
        <Grid>
          <Grid.Row className="act-member-row-custom">
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={16}
              className="add-member-column"
            >
              {editPermission ? (
                <div className={editPermission ? null : 'permission-pop-up'}>
                  {this.renderDropdown()}
                </div>
              ) : (
                <>
                  <div className="custom-segment">
                    <CustomTooltip
                      state={get(user, 'options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '90',
                      }}
                      position="top left"
                      wide="very"
                    >
                      <label className="participants-title-label">
                        {t(
                          'activity.activity_plan.invite_organisation_members'
                        )}
                      </label>
                    </CustomTooltip>
                    <label className="search-label-participants">
                      {t(
                        'activity.activity_plan.search_for_existing_users'
                      )}{' '}
                    </label>
                    <Search
                      className="search-bar-invite-user"
                      loading={isLoading}
                      placeholder={t('actions.search')}
                      onResultSelect={(e, { result }) =>
                        this.handleResultSelect(result)
                      }
                      onSearchChange={debounce(this.handleSearchChange, 300, {
                        leading: true,
                      })}
                      results={data}
                      value={searchQuery}
                      resultRenderer={({ name }) => <label>{name}</label>}
                      disabled={currentActivity.statusId >= 2 ? true : false}
                      // {...this.props}
                      noResultsMessage={
                        <label>
                          {t('activity.activity_plan.no_contractor_found')}
                          <span>
                            {' '}
                            {t('activity.activity_plan.add_new_contractor')}
                          </span>
                        </label>
                      }
                    />
                  </div>

                  <Divider section />
                  {/* <div className="new-member-segment-custom-participant"> */}
                  <AvForm
                    ref={(c) => (this.form = c)}
                    onValidSubmit={(event, values) =>
                      this.handleValidSubmit(event, values)
                    }
                    onInvalidSubmit={() => this.handleInvalidSubmit()}
                    model={form}
                    autoComplete="off"
                    className="invite-user-modal-custom"
                  >
                    <Grid>
                      <Grid.Row className="column-space">
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AvField
                            name="firstName"
                            type="text"
                            label={
                              <div className="participant-input-label">
                                {t('formulary.first_name')}
                              </div>
                            }
                            className="input-fields-radius"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t(
                                  'formulary.validation.first_name_required'
                                ),
                              },
                            }}
                            autoComplete="off"
                          />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                          <AvField
                            name="surname"
                            type="text"
                            label={
                              <div className="participant-input-label">
                                {t('formulary.surname')}
                              </div>
                            }
                            className="input-fields-radius"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t(
                                  'formulary.validation.surname_required'
                                ),
                              },
                            }}
                            autoComplete="off"
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <AvField
                      name="email"
                      type="email"
                      label={
                        <div className="participant-input-label">
                          {t('formulary.email')}
                        </div>
                      }
                      className="input-fields-radius"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: t(
                            'formulary.validation.email_required'
                          ),
                        },
                      }}
                      autoComplete="off"
                    />
                    <AvField
                      name="message"
                      type="textarea"
                      className="input-fields-radius-msg"
                      label={
                        <CustomTooltip
                          state={get(user, 'options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: '88',
                          }}
                          position="top left"
                          wide="very"
                        >
                          <div className="participant-input-label">
                            {t('activity.activity_plan.message_for_guest_user')}
                          </div>
                        </CustomTooltip>
                      }
                      rows="4"
                      validate={{
                        required: {
                          value: false,
                        },
                      }}
                    />

                    {this.renderParticipantDropdown()}

                    {permissionError || isPermissionLabelVisible ? (
                      <div className="invalid-permission-activity-participant ">
                        {t(
                          'activity.activity_plan.please_set_permissions_new_member'
                        )}
                      </div>
                    ) : null}
                    <div className="submit-button-right-align">
                      <Button
                        type="submit"
                        className="Primary-Button"
                        disabled={actPut.activityMembers ? true : false}
                        loading={actPut.activityMembers ? true : false}
                      >
                        <CustomTooltip
                          state={get(user, 'options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: '89',
                          }}
                          position="top left"
                          wide="very"
                        >
                          <div>{t('activity.activity_plan.invite')}</div>
                        </CustomTooltip>
                      </Button>
                    </div>
                  </AvForm>
                  {/* </div> */}
                </>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      addActivityMember,
      updateActivityMember,
      getOrgMembers,
    },
    dispatch
  );
};

ActivityMember = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityMember));

export { ActivityMember };
